<div class="modal-backdrop fade show" *ngIf="visible && !isAddingQuantity"></div>

<div class="modal fade show inv-modal" [class.d-block]="visible && !isAddingQuantity" tabindex="-1">
  <div class="modal-dialog modal-xl modal-dialog-centered inv-modal-dialog">
    <div class="modal-content shadow-lg inv-modal-content">
      <div class="modal-header"
        style="background: linear-gradient(to right, #1F7A8C, #107C8F) !important; border: none;">
        <div class="d-flex align-items-center justify-content-between w-100">
          <!-- Left Section: Icon and Title -->
          <div class="d-flex align-items-center">
            <div class="section-icon me-2" style="
          background: rgba(255, 255, 255, 0.2);
          width: 36px;
          height: 36px;
          border-radius: 8px;
          display: flex;
          align-items: center;
          justify-content: center;
        ">
              <i class="bi bi-box text-white"></i>
            </div>
            <h5 class="modal-title text-white fw-bold m-0">
              {{ isEditing ? "Edit" : "Add" }} {{ isServiceItem ? 'Service' : (isFinishedGood ? 'Product' : 'Raw Material') }}
            </h5>
          </div>

          <!-- Right Section: Close Button -->
          <button type="button" class="close-button" (click)="quickClose.emit()">×</button>
        </div>
      </div>
      <div class="modal-body">
        <!-- Supplier Section (Only shown for Raw Materials) -->
<div class="form-section supplier-section mb-4" *ngIf="!isFinishedGood">
          <div class="section-header">
            <h5 class="section-title">
              Supplier Information
            </h5>
          </div>

          <div class="form-tabs mb-3">
            <div class="nav" role="tablist">
              <button class="nav-link" [class.active]="!isCreatingSupplier"
                [ngClass]="{'tab-selected': !isCreatingSupplier}" (click)="onSelectExistingSupplier()">
                <i class="bi bi-list-ul me-2"></i>Select Existing Supplier
              </button>
              <button type="button"
              class="nav-link"
              (click)="navigateToAddSupplierClick.emit()">
        <i class="bi bi-plus-circle me-2"></i> Add Suppliers
      </button>
            </div>
          </div>

          <div *ngIf="!isCreatingSupplier" class="mb-3">
            <div class="form-group">
              <app-single-select-dropdown
                [options]="supplierOptions"
                [selectedValue]="selectedSupplier ? String(selectedSupplier.supplierID) : null"
                placeholder="Select a supplier"
                (selectedValueChange)="onDesktopSupplierSelected($event)">
              </app-single-select-dropdown>
            </div>
          </div>
          <form *ngIf="isCreatingSupplier" [formGroup]="supplierForm" class="row g-3">
            <!-- Supplier form fields here -->
          </form>
        </div>

        <!-- Category Section -->
        <div class="form-section category-section mb-4">
          <div class="section-header">
            <h5 class="section-title">
              Category Information
            </h5>
          </div>

          <div class="form-tabs mb-3">
            <div class="nav" role="tablist">
              <button class="nav-link" [class.active]="!isCreatingCategory"
                [ngClass]="{'tab-selected': !isCreatingCategory}" (click)="onSelectExistingCategory()">
                <i class="bi bi-list-ul me-2"></i>Select Existing Category
              </button>

              <button class="nav-link" [class.active]="isCreatingCategory"
                [ngClass]="{'tab-selected': isCreatingCategory}" (click)="onCreateCategoryTab()">
                <i class="bi bi-plus-circle me-2"></i>Add Category
              </button>
            </div>
          </div>

          <div *ngIf="!isCreatingCategory" class="mb-3">
            <div class="form-group">
              <app-single-select-dropdown
                [options]="categoryOptions"
                [selectedValue]="selectedCategory ? String(selectedCategory.categoryId) : null"
                placeholder="Select a category"
                (selectedValueChange)="onDesktopCategorySelected($event)">
              </app-single-select-dropdown>
            </div>
          </div>

          <form *ngIf="isCreatingCategory" [formGroup]="categoryForm" class="row g-3">
            <div class="col-md-6">
              <div class="form-group">
                <label class="form-label">Category Name</label>
                <div class="input-group">
                  <span class="input-group-text bg-transparent border-end-0">
                    <i class="bi bi-tag text-secondary"></i>
                  </span>
                  <input type="text" class="form-control border-start-0" formControlName="categoryName" />
                </div>
              </div>
            </div>
            <div class="col-12 mt-3 d-flex justify-content-end">
              <button class="btn btn-gradient-primary" (click)="createCategoryClick.emit()">
                <i class="bi bi-plus-circle"></i>
                <span>Create Category</span>
              </button>
            </div>
          </form>

        </div>

        <!-- Item Details Section -->
        <div class="form-section item-section mb-4" *ngIf="
    (isFinishedGood && selectedCategory) ||
    (!isFinishedGood && selectedSupplier && selectedCategory)
  ">
<div class="section-header d-flex justify-content-between align-items-center mb-3">
  <h5 class="section-title mb-0">Item Details</h5>
  <button type="button"
          class="btn btn-gradient-primary btn-sm"
          *ngIf="isEditing && !isFinishedGood"
          (click)="togglePurchaseFieldsClick.emit()">
    <i class="bi" [class.bi-pencil]="!showPurchaseFields" [class.bi-x]="showPurchaseFields"></i>
    {{ showPurchaseFields ? 'Cancel Update' : 'Update Purchase Price' }}
  </button>
</div>

          <form [formGroup]="inventoryForm" class="row g-3">
            <div class="col-md-6">
              <div class="form-group">
                <label class="form-label">Item Name</label>
                <div class="input-group">
                  <span class="input-group-text bg-transparent border-end-0">
                    <i class="bi bi-box2 text-secondary"></i>
                  </span>
                  <input type="text" class="form-control border-start-0"
                    [class.is-invalid]="isInvalid('itemName')" formControlName="itemName" />
                </div>
                <div class="field-error" *ngIf="errorFor('itemName', 'Item name') as err">{{ err }}</div>
              </div>
            </div>
    <div class="col-md-6" *ngIf="!isFinishedGood">
      <div class="form-group">
        <label class="form-label">Reorder Level</label>
        <div class="input-group">
          <span class="input-group-text bg-transparent border-end-0">
            <i class="bi bi-arrow-repeat text-secondary"></i>
          </span>
          <input type="number" class="form-control border-start-0"
            [class.is-invalid]="isInvalid('lowStockThreshold')" formControlName="lowStockThreshold" />
        </div>
        <div class="field-error" *ngIf="errorFor('lowStockThreshold', 'Reorder level') as err">{{ err }}</div>
      </div>
    </div>
    <!-- Buy Out (spec §4): purchased and resold as-is, no BOM required -->
    <div class="col-md-6" *ngIf="!isFinishedGood && !isServiceItem">
      <div class="form-group">
        <label class="form-label d-block">&nbsp;</label>
        <div class="form-check">
          <input type="checkbox" class="form-check-input" id="isBuyoutCheck" formControlName="isBuyout" />
          <label class="form-check-label" for="isBuyoutCheck">
            Buy Out — purchased and resold as-is (no BOM required)
          </label>
        </div>
      </div>
    </div>
    <!-- Purchase Price (Add mode for Raw Materials) -->
    <div class="col-md-6" *ngIf="!isFinishedGood && !isEditing">
      <div class="form-group">
        <label class="form-label">Purchase Price</label>
        <div class="input-group">
          <span class="input-group-text bg-transparent border-end-0">
            <i class="text-secondary fw-bold">R</i>
          </span>
          <input type="number" class="form-control border-start-0" formControlName="purchasePrice" step="0.01" min="0"
            appNumericInput />
        </div>
        <div class="text-danger small mt-1" *ngIf="purchasePriceError">
          {{ purchasePriceError }}
        </div>
      </div>
    </div>
    <div class="row" *ngIf="showPurchaseFields && isEditing && !isFinishedGood">
      <div class="alert alert-info p-3 mb-3" *ngIf="isEditing && !isFinishedGood && showPurchaseFields">
        <div class="d-flex align-items-center">
          <i class="bi bi-info-circle me-2 fs-5"></i>
          <div>
            <h6 class="mb-1 fw-semibold">Update Purchase Details</h6>
            <p class="mb-1 small">Please enter the new purchase price and quantity for this item. These values will be used to calculate the updated unit cost.</p>
            <p class="mb-0 small text-muted"><i class="bi bi-info-circle me-1"></i> Note: The quantity entered will be added to your current stock level.</p>
          </div>
        </div>
      </div>
    <div class="col-md-6">

      <div class="form-group">
        <label class="form-label">New Purchase Price</label>
        <div class="input-group">
          <span class="input-group-text bg-transparent border-end-0">
            <i class="text-secondary fw-bold">R</i>
          </span>
          <input type="number" class="form-control border-start-0" formControlName="purchasePrice" step="0.01" min="0"
            appNumericInput />
        </div>
        <div class="text-danger small mt-1" *ngIf="purchasePriceError">
          {{ purchasePriceError }}
        </div>
      </div>
    </div>
    <div class="col-md-6">
      <div class="form-group">
        <label class="form-label">New Purchase Quantity</label>

        <div class="input-group">
          <span class="input-group-text bg-transparent border-end-0">
            <i class="bi bi-123 text-secondary"></i>
          </span>
          <input type="number" class="form-control" formControlName="quantityToAdd" min="1" />

        </div>
      </div>
    </div>
  </div>
            <div class="col-md-6" *ngIf="!isFinishedGood && !isEditing">
              <div class="form-group">
                <label class="form-label">Unit Cost</label>
                <div class="input-group">
                  <span class="input-group-text bg-transparent border-end-0">
                    <i class="text-secondary fw-bold">R</i>
                  </span>
                  <input type="number" class="form-control border-start-0" formControlName="unitCost" step="0.01"
                    min="0" [readonly]="!isEditing && !isAddingQuantity"  />
                </div>
                <small class="text-muted" style="margin-left: 5px;">Calculated by dividing purchase price with initial quantity</small>
              </div>
            </div>
            <div class="col-md-6" *ngIf="isFinishedGood">
              <div class="form-group">
                <label class="form-label">{{ isServiceItem ? 'Price' : 'Selling Price' }}</label>
                <div class="input-group">
                  <span class="input-group-text bg-transparent border-end-0">
                    <i class="text-secondary fw-bold">R</i>
                  </span>
                  <input type="number" class="form-control border-start-0"
                    [class.is-invalid]="isInvalid('sellingPrice')" formControlName="sellingPrice" />
                </div>
                <div class="field-error" *ngIf="errorFor('sellingPrice', 'Price') as err">{{ err }}</div>
                <!-- Spec §3: selling price is optional at creation and defaults to R0. -->
                <small class="text-muted" *ngIf="!isServiceItem">Optional — defaults to R0 until set in the Cost Calculator</small>
              </div>
            </div>

            <div class="col-md-6" *ngIf="!isFinishedGood && !isEditing">
              <div class="form-group">
                <label class="form-label">Initial Quantity</label>
                <div class="input-group">
                  <span class="input-group-text bg-transparent border-end-0">
                    <i class="bi bi-123 text-secondary"></i>
                  </span>
                  <app-area-quantity-input
                    [uomCode]="getSelectedUomCode()"
                    [value]="inventoryForm.get('quantityToAdd')?.value ?? 0"
                    (valueChange)="setQuantityToAdd($event)"
                    cssClass="form-control border-start-0"
                  />
                </div>
              </div>
            </div>

            <div class="col-md-6">
              <div class="form-group">
                <label class="form-label">SKU</label>
                <div class="input-group">
                  <span class="input-group-text bg-transparent border-end-0">
                    <i class="bi bi-upc-scan text-secondary"></i>
                  </span>
                  <input type="text" class="form-control border-start-0" formControlName="itemCode" />
                </div>
                <small class="text-muted">Leave blank to auto-generate</small>
              </div>
            </div>
            <!-- Service: time in minutes is the quantity, and the unit is fixed. -->
            <div class="col-md-6" *ngIf="isServiceItem">
              <div class="form-group">
                <label class="form-label">Time (Minutes)</label>
                <div class="input-group">
                  <span class="input-group-text bg-transparent border-end-0">
                    <i class="bi bi-clock text-secondary"></i>
                  </span>
                  <input type="number" class="form-control border-start-0" min="1" step="1"
                    [class.is-invalid]="isInvalid('quantityToAdd')" formControlName="quantityToAdd" />
                </div>
                <div class="field-error" *ngIf="errorFor('quantityToAdd', 'Time') as err">{{ err }}</div>
                <small class="text-muted">How long this service takes to deliver</small>
              </div>
            </div>

            <div class="col-md-6">
              <div class="form-group">
                <label class="form-label">Unit of Measure</label>
                <div class="input-group">
                  <span class="input-group-text bg-transparent border-end-0">
                    <i class="bi bi-box2 text-secondary"></i>
                  </span>
                  <!-- A Service is measured in minutes, so the unit is fixed
                       rather than chosen. serviceUomLocked pins the control. -->
                  <input *ngIf="isServiceItem && serviceUomLocked" type="text" class="form-control border-start-0"
                    [value]="minutesUom?.uomName || 'Minutes'" readonly />
                  <select *ngIf="!isServiceItem || !serviceUomLocked" class="form-control border-start-0"
                    formControlName="PurchaseUOMID"
                    [class.is-invalid]="isInvalid('PurchaseUOMID')"
                    [compareWith]="compareUOM">
                    <option [ngValue]="null" disabled>Select Unit of Measure</option>
                    <option *ngFor="let uom of displayUomList" [ngValue]="uom.uomid">
                     {{ uom.uomName }}
                    </option>
                  </select>
                </div>
                <div class="field-error" *ngIf="errorFor('PurchaseUOMID', 'Unit of measure') as err">{{ err }}</div>
                <small class="text-muted" *ngIf="isServiceItem && serviceUomLocked">Services are measured in minutes</small>
              </div>
            </div>

          </form>
        </div>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" (click)="cancel.emit()">Cancel</button>
        <button type="button" class="btn btn-gradient-primary" (click)="onSaveClick()">
          <i class="bi bi-check2-circle"></i>
          <span>{{ isEditing ? "Update" : "Add" }} {{ isServiceItem ? 'Service' : (isFinishedGood ? 'Product' : 'Raw Material') }}</span>
        </button>
      </div>
    </div>
  </div>
</div>
